export default "__VITE_ASSET__CfKIdLnE__"